import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';

export const pisCofins: SelectType[] = [
  { label: 'Todos', value: -1 },
  { label: 'Incidentes', value: 0 },
  { label: 'Não Incidentes', value: 1 },
];
